import React from "react";

function validarEmail(valor) {
  if (
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
      valor
    )
  ) {
    //alert("La dirección de email " + valor + " es correcta!.");
    return "aceptadoEmail";
  } else {
    return "errorEmail";
  }
}

export default validarEmail;
